import Card from 'react-bootstrap/Card';
import "../css/styles.css"
import "../css/Montserrat.css"
import "../css/Roboto.css"
import "../js/scripts.js"
import "../css/Course.css"

const CardItem = ({ image, title, tagline, body }) => {
    return (
        <div style={{ minWidth: '300px', flex: '0 0 auto' }}>
            <Card style={{ border: 'none', textAlign: 'center' }}>
                <Card.Img 
                    variant="top" 
                    src={image} 
                    style={{ objectFit: 'cover', borderRadius: '1rem', maxHeight: '20rem' }} 
                />
                <Card.Body>
                    <Card.Title style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>{title}</Card.Title>
                    {tagline && (
                        <p style={{ fontStyle: 'italic', color: '#555', fontSize: '1rem' }}>
                            {tagline}
                        </p>
                    )}
                    <Card.Text style={{ textAlign: 'justify', marginTop: '0.5rem' }}>
                        {body}
                    </Card.Text>
                </Card.Body>
            </Card>
        </div>
    );
};


export default CardItem;